import http from "../core/http";
const group = 'store';

export const getInitialDataRequest =  async (data) => {
    return await http.post(`${group}/getInitialData`, data).then(res => res.data).catch(http.defaultCatch);
}
export const getVesselUsersRequest =  async (data) => {
    return await http.post(`${group}/getVesselUsers`, data).then(res => res.data).catch(http.defaultCatch);
}
export const getDockingQueueRequest =  async (data) => {
    return await http.post(`${group}/getDockingQueue`, data).then(res => res.data).catch(http.defaultCatch);
}
export const getTransactionsRequest =  async (data) => {
    return await http.post(`${group}/getTransactions`, data).then(res => res.data).catch(http.defaultCatch);
}
export const findTransactionRequest =  async (data) => {
    return await http.post(`${group}/findTransaction`, data).then(res => res.data).catch(http.defaultCatch);
}
export const getActivitiesRequest =  async (data) => {
    return await http.post(`${group}/getActivities`, data).then(res => res.data).catch(http.defaultCatch);
}




